<!-- 销售退回申请模板 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog  title="选择销售退回申请"  :visible.sync="dialogVisible"  width="90%" :append-to-body="true">
			<div class='components_content_box'>
				<div class="page_content_top">
					<div class="page_content_top_line">
						<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]">
							<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
								<el-input v-if="formOneValue.entityField == 'psrgmBuycus'"
									v-model.trim="getRequestData.psrgmBuycusName" 
									@focus="$refs['showSelectData'].openBox('supplierList',formOneValue.entityField,'smId')"
									size="mini" :maxlength="$store.state.inputLength"></el-input>
								<el-input v-else  v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="page_content_center">
					<el-table  v-if="pageShowData[1]" stripe :data="returnData.list"  height="100%" border @selection-change="selecDataAction"  style="height:500px;width: 100%" highlight-current-row>
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column type="expand">
						    <template slot-scope="props">
								<el-tabs type="border-card">
									<!-- 明细 -->
									<el-tab-pane :label="pageShowData[3].jciName">
										<el-table v-if="pageShowData[3]" :data="props.row.desuRgapplyDetails"  border  style="width: 100%">
											
											<!-- <el-table-column prop="bgmName" label="通用名称"  >
												<template  slot-scope="scope">
													<el-checkbox v-model="selectDetails" :label="JSON.stringify(scope.row)" @change="selectDetailsction">
														{{scope.row.bgmName}}
													</el-checkbox>
												</template>
											</el-table-column> -->
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
												<template  slot-scope="scope">
													<div v-if="tableValye.entityField == 'rgadProdate'">
														{{$common.getLocalTime(scope.row.rgadProdate)}}
													</div>
													<div v-else-if="tableValye.entityField == 'rgadEffdate'">
														{{$common.getLocalTime(scope.row.rgadEffdate)}}
													</div>
													
													<div v-else-if="tableValye.entityField == 'bgmName'">
														<el-checkbox v-model="selectDetails" :label="JSON.stringify(scope.row)" @change="selectDetailsction">
															{{scope.row.bgmName}}
														</el-checkbox>
													</div>
													<div v-else>
														{{scope.row[tableValye.entityField]}}
													</div>
												</template>
											</el-table-column>
										</el-table>
									</el-tab-pane>
									<!-- 辅助信息 -->
									<el-tab-pane  :label="pageShowData[2].jciName">
										<el-table v-if="pageShowData[2]" :data="[props.row.desuRgapplySupInfo]"  border style="width: 100%">
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
												<template  slot-scope="scope">
													<div>
														{{scope.row[tableValye.entityField]}}
													</div>
												</template>
											</el-table-column>
										</el-table>
									</el-tab-pane>
								</el-tabs>
						    </template>
						</el-table-column>
						<el-table-column
							v-if="tableValye.isShow==1"
							v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" 
							:key="tableKey" 
							:prop="tableValye.entityField"  
							:label="tableValye.showField">
							<template  slot-scope="scope">
								
								<div v-if="tableValye.entityField == 'rgamRapdate'">
									{{$common.getLocalTime(scope.row[tableValye.entityField])}}
								</div>
								
								<div v-else>
									{{scope.row[tableValye.entityField]}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page_content_bottom">
					<el-pagination
						background
						@size-change="setDataPageSize"
						@current-change="setDataPageNumber"
						:current-page="getRequestData.page"
						:page-sizes="[30,50,100,500]"
						:page-size="30"
						layout="total, sizes, prev, pager, next, jumper"
						:total="returnData.total">
					</el-pagination>
				</div>
			</div>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sendAction">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'salesReturnTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				psrgmPurchaser:'',
				psrgmBuycus:'',  // 购进单位
				psrgmBuycusName:'', // 购进单位名称
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			selectedDataList:[],
			selectDetails:[],
			selectSendDetailsList:[],
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		
	},
	//方法集合
	methods: {
		isShowData(name,value){
			console.log(name)
			switch(name){
				case 'psrgmBuycus':
					var dataInfo = sessionStorage.getItem('selectSupplierData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.psrgmBuycus = dataInfo.smId
						this.getRequestData.psrgmBuycusName = dataInfo.smName
						
					}
					break;
				default :
					this.sendDataInfo[name] = value
				
			}
			
		},
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		sendAction(){
			if(this.selectDetails.length<1){
				this.$message({
					message: '请选择明细',
					type: 'error'
				});
				return false
			}
			var dataOne = this.selectedDataList[0]
			var saveData = []
			
			
			console.log(this.selectSendDetailsList)
			// sessionStorage.setItem('selectReceiptOrderDetails',saveData)
			this.dialogVisible = false
			this.$parent.extractData(this.selectSendDetailsList)
		},
		// 获取数据列表
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/salesReturn')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selecDataAction(data){
			this.selectedDataList =  data
		},
		selectDetailsction(data){
			// this.selectDetails =  data
			var list = JSON.parse(JSON.stringify(this.selectDetails))
			var newDataList = []
			// console.log(this.selectDetails)
			if(this.selectDetails.length>=1){
				var lastDataInfo = JSON.parse(list.pop())
				this.selectSendDetailsList = []
				this.selectDetails.forEach((values,keys)=>{
					var thisInfo = JSON.parse(values)
					if(lastDataInfo.rgamId==thisInfo.rgamId){
						this.selectSendDetailsList.push(thisInfo.rgadId)
						newDataList.push(values)
					}
				})
				
			}
			this.selectDetails =  newDataList
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getSalesReturn(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataList = []
				this.selectDetails = []
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
.el-dialog__body{
	height: 1000px;
}
</style>
